import $ from 'jquery'

const bounceTransitionClass = `km-bounce-transition`

// const transitionEnd = getCorrectEventName(window, 'transitionend')

const getTransition = (origin) => {
  const transition = {
    beforeEnter(el) {
      $(el).addClass(bounceTransitionClass)

      if (!el.dataset) el.dataset = {}

      el.dataset.transformOrigin = el.style.transformOrigin
      if (origin) {
        el.style.transformOrigin = origin
      }
    },
    afterEnter(el) {
      $(el).removeClass(bounceTransitionClass)
      el.style.transformOrigin = el.dataset.transformOrigin
    },
    beforeLeave(el) {
      if (!el.dataset) el.dataset = {}
      el.dataset.oldTransformOrigin = el.style.transformOrigin
      if (origin) {
        el.style.transformOrigin = origin
      }
    },
    afterLeave(el) {
      $(el).removeClass(bounceTransitionClass)
      el.style.transformOrigin = el.dataset.oldTransformOrigin
    },
  }

  return transition
}

export const BounceTransition = {
  name: 'KBounceTransition',
  functional: true,
  render(h, { children }) {
    const data = {
      props: {
        name: 'km-bounce-transition',
      },
      on: getTransition(),
    }
    return h('transition', data, children)
  },
}

export const BounceTopTransition = {
  name: 'KBounceTopTransition',
  functional: true,
  render(h, { children }) {
    const data = {
      props: {
        name: 'km-bounce-transition',
      },
      on: getTransition('center top'),
    }
    return h('transition', data, children)
  },
}

export const BounceRightTransition = {
  name: 'KBounceRightTransition',
  functional: true,
  render(h, { children }) {
    const data = {
      props: {
        name: 'km-bounce-transition',
      },
      on: getTransition('right center'),
    }
    return h('transition', data, children)
  },
}

export const BounceBottomTransition = {
  name: 'KBounceBottomTransition',
  functional: true,
  render(h, { children }) {
    const data = {
      props: {
        name: 'km-bounce-transition',
      },
      on: getTransition('center bottom'),
    }
    return h('transition', data, children)
  },
}

export const BounceLeftTransition = {
  name: 'KBounceLeftTransition',
  functional: true,
  render(h, { children }) {
    const data = {
      props: {
        name: 'km-bounce-transition',
      },
      on: getTransition('left center'),
    }
    return h('transition', data, children)
  },
}
